module.exports = __webpack_public_path__ + "static/media/logo.2a09a0f5.svg";